import React from 'react';
import at from 'lodash/at';
import { useField } from 'formik';
import TextField from '@mui/material/TextField'
import { Trans } from 'react-i18next'
import dataStorage from 'dataStorage';
import PhoneCountry from 'components/PhoneCountry'
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import FormHelperText from '@mui/material/FormHelperText';

const ListCountry = [
    { code: 'US', value: 'USA', label: 'United States', phone: '1' },
    { code: 'HK', value: 'HKG', label: 'Hong Kong', phone: '852' },
    { code: 'AU', value: 'AUS', label: 'Australia', phone: '61' },
    { code: 'AT', value: 'AUT', label: 'Austria', phone: '43' },
    { code: 'BE', value: 'BEL', label: 'Belgium', phone: '32' },
    { code: 'CA', value: 'CAD', label: 'Canada', phone: '1' },
    { code: 'CN', value: 'CHN', label: 'China', phone: '86' },
    { code: 'IE', value: 'IRL', label: 'Ireland', phone: '353' },
    { code: 'IL', value: 'ISR', label: 'Israel', phone: '972' },
    { code: 'IT', value: 'ITA', label: 'Italy', phone: '39' },
    { code: 'MY', value: 'MYS', label: 'Malaysia', phone: '60' },
    { code: 'NO', value: 'NOR', label: 'Norway', phone: '47' },
    { code: 'PT', value: 'PRT', label: 'Portugal', phone: '351' },
    { code: 'SG', value: 'SGP', label: 'Singapore', phone: '65' },
    { code: 'ES', value: 'ESP', label: 'Spain', phone: '34' },
    { code: 'SE', value: 'SWE', label: 'Sweden', phone: '46' },
    { code: 'CH', value: 'CHE', label: 'Switzerland', phone: '41' },
    { code: 'GB', value: 'GBR', label: 'United Kingdom', phone: '44' },
    { code: 'VN', value: 'VNM', label: 'Viet Nam', phone: '84' }
];

export default function InputField({ ...props }) {
    const { errorText, helperText, variant = 'outlined', translate = true, ...rest } = props;
    const [field, meta, helper] = useField(props);
    const { setValue: setFieldValue } = helper;
    const [touched, error] = at(meta, 'touched', 'error');
    const isError = touched && error && true;

    function _renderHelperText() {
        let text = ''
        if (touched && error) {
            text = error;
        } else if (helperText) {
            text = helperText
        }
        return <Trans values={{ label: dataStorage.translate(rest.label), max: rest.maxLength }}>{text}</Trans>
    }

    const onChange = (data) => {
        const value = `+${data.phone}|${data.phoneNumber}`
        setFieldValue(value)
    }

    const phone = React.useMemo(() => {
        const phoneNumber = (field.value + '').replace('+', '')
        const phoneCode = phoneNumber.split('|')[0]
        const country = ListCountry.find(e => e.phone === phoneCode)
        return {
            ...country,
            phoneNumber: phoneNumber.split('|')[1],
        }
    }, [field.value])
    return (
        <FormControl name={field.name} onBlur={field.onBlur} {...rest} error={isError}>
            <PhoneCountry
                {...rest}
                onBlur={field.onBlur}
                label={rest.label}
                error={isError}
                phoneValue={phone}
                onChange={onChange} />
            <FormHelperText>{_renderHelperText()}</FormHelperText>
        </FormControl>
    );
}
